module.exports = __webpack_public_path__ + "static/media/honest.5baad85f.png";